module.exports = __webpack_public_path__ + "img/icon_赛事等级徽章_D级@3x.cb45b042.png";